var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 177,
    viewBox: "0 0 172 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.526 94.2197C132.516 71.1809 117.886 48.4583 94.8468 43.4674C71.8079 38.4765 49.0853 53.1073 44.0945 76.1462L35.0577 117.862L118.489 135.935L127.526 94.2197ZM129.382 152.853L18.1402 128.755L30.1893 73.1339C36.8438 42.4154 67.1406 22.9077 97.8591 29.5622C128.578 36.2167 148.085 66.5135 141.431 97.232L129.382 152.853Z",
    fill: "#D5DDE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.106 139.946C143.958 140.781 146.375 144.713 145.505 148.73C144.634 152.748 140.807 155.328 136.955 154.493L11.4233 127.299C7.5717 126.465 5.15478 122.532 6.02498 118.515C6.89518 114.498 10.723 111.918 14.5746 112.752L140.106 139.946Z",
    fill: "#D5DDE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7803 20.4063C92.6249 16.5074 96.5661 14.0522 100.583 14.9224C104.6 15.7926 107.172 19.6587 106.327 23.5576L103.269 37.6767C102.424 41.5756 98.4829 44.0308 94.4659 43.1606C90.4489 42.2904 87.8771 38.4243 88.7217 34.5254L91.7803 20.4063Z",
    fill: "#D5DDE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5544 144.554L79.8631 141.588C79.0237 145.463 81.408 149.269 85.1887 150.088L82.1487 164.121C71.1607 161.741 64.1044 150.952 65.9641 139.71L66.1719 138.622L69.212 124.588L110.286 133.486L107.246 147.52C104.727 159.145 93.4909 166.578 82.1487 164.121L85.1887 150.088C88.9695 150.907 92.7149 148.429 93.5544 144.554Z",
    fill: "#D5DDE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyNotifications);
export default __webpack_public_path__ + "static/media/empty-notifications.42e8f3dd88986b25c0aef8c8b91f1336.svg";
export { ForwardRef as ReactComponent };